// extracted by mini-css-extract-plugin
export default {"fs":"_5227adc750 b4bc637d16"};